import api from "@/http/apis"
import {
	ElMessage
} from "element-plus"
import {
	sessionStorage
} from "@/utils/sessionStorage"
export default ({
	namespaced: "true",
	state: {
		userInfo: "",
		userMenu: [],
	},
	getters: {},
	mutations: {
		setUserInfo(state, val) {
			state.userInfo = val
			sessionStorage.set('user', state)
		},
		setUserMenu(state,val) {
			state.userMenu = val
			sessionStorage.set('user', state)
		},		
	},
	actions: {
		async setUserMenu(context) {
			const {
				data
			} = await api.menuApi.getUserMenuTree()
			if (data.isSuccessful) {
				if (data.resultObj) {
					context.commit('setUserMenu',data.resultObj)
					location.reload()
				} else {
					ElMessage({
						message: "当前账号没有设置可用的菜单，请联系管理员",
						type: "error",
					})
				}
			} else {
				if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					})
				} else {
					ElMessage({
						message: '未知错误，请联系管理员',
						type: "error",
					})
				}
			}
		}
	},

})
